module.exports = __webpack_public_path__ + "static/img/4.1f7a1ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/6/4.png
// module id = /yMJ
// module chunks = 1